export default __webpack_public_path__ + "images/0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be.png";